import React from "react";
import CustomHelmet from "../components/CustomHelmet";
import MainLayout from "../components/MainLayout";
import styled from "styled-components";
import { Container } from "../styles/container";
import Bredcrumb from "../components/Bredcrumb";

const TextContent = styled.div`
  margin: 40px 0px;
  .campus {
    margin: 40px auto;
  }
  > h4 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.4;
    color: var(--dark);
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  > p {
    font-size: 14px;
    color: var(--dark);
    line-height: 1.5;
    margin-bottom: 10px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
  > ul {
    margin-bottom: 12px;
    list-style: none;
    li {
      padding-left: 15px;
      font-size: 14px;
      line-height: 1.5;
      color: var(--dark);
      @media (max-width: 768px) {
        font-size: 12px;
      }
      > strong {
        width: max-content;
        white-space: nowrap;
        margin-right: 4px;
      }
    }
  }
`;

const PrivacyPolicy = () => {
  return (
    <>
      <CustomHelmet
        title="Privacy Policy - Arcaptor Technologies"
        description="Review the Privacy Policy of Arcaptor Technologies. Learn how we collect, use, and protect your personal data while ensuring transparency and compliance with privacy regulations."
      />
      <MainLayout>
        <Bredcrumb
          paddingY="30px"
          imgStyleHeight="300px"

          heading="Privacy Policy"
          image="./images/Privacy.png"
        />
        <Container>
          <TextContent>
            <h2 className="main_heading">Privacy Policy</h2>
            <p>
              At ARCAPTOR TECHNOLOGIES, we value and respect the privacy of
              every individual visiting our website. We are committed to
              safeguarding the privacy and security of all personal information
              collected from our visitors. Below is an outline of our policy
              regarding the collection, use, and protection of personal
              information.
            </p>
            <br />
            <h4>Information Collection and Use</h4>
            <br />
            <p>
              When you visit our website to read or download information,
              ARCAPTOR TECHNOLOGIES collects and stores standard
              internet-related information, including:
            </p>
            <br />
            <ul>
              <li>Internet Protocol (IP) address</li>
              <li>Date and time of access</li>
              <li>Browser type and operating system</li>
              <li>Pages visited</li>
            </ul>
            <br />

            <p>
              This data is collected solely to enhance the user experience and
              improve the usefulness of our website. It is utilized only for
              statistical purposes.
            </p>
            <br />
            <p>
              We may also collect personal information, such as your name,
              telephone number, and email address, when voluntarily provided by
              you. This information is used to:
            </p>
            <br />
            <ul>
              <li>Respond to your queries and requests</li>
              <li>Process bids and related activities</li>
            </ul>
            <br />
            <h4>Disclosure of Information</h4>
            <br />
            <p>
              <b> ARCAPTOR TECHNOLOGIES</b> does not share personally
              identifiable information without your consent, except:
            </p>
            <br />
            <ul>
              <li>Where required by law</li>
              <li>To protect our rights, property, or personal safety</li>
            </ul>
            <br />
            <h4>Policy Updates</h4>
            <br />
            <p>
              <b> ARCAPTOR TECHNOLOGIES</b> reserves the right to amend, update,
              or modify this privacy policy at any time without prior notice.
            </p>
            <br />
            <h4>Copyright</h4>
            <br />
            <p>Copyright © ARCAPTOR TECHNOLOGIES. All rights reserved.</p>
          </TextContent>
        </Container>
      </MainLayout>
    </>
  );
};

export default PrivacyPolicy;
